import { render, staticRenderFns } from "./indexMenus.vue?vue&type=template&id=3b5b2522&scoped=true&"
import script from "./indexMenus.vue?vue&type=script&lang=js&"
export * from "./indexMenus.vue?vue&type=script&lang=js&"
import style0 from "./indexMenus.vue?vue&type=style&index=0&id=3b5b2522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b2522",
  null
  
)

export default component.exports